// tslint:disable:jsx-no-multiline-js (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
import * as React from 'react';
import Radium from '../../../styling/rostelecom-radium';
import Color from 'color';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../../styling/rostelecom-styles-store';
import { IReactRadiumFreeStyles } from '../../../../../base/radium-types';

export interface ILoginInputProps extends React.Props<LoginInput> {
    styleParams: IRostelecomStyleParamsStoreState;
    formProps: IFormComponentProps;
    disabled?: boolean;
    type?: string;
    label?: string;
}

@Radium
class LoginInput extends InternationalizedComponent<ILoginInputProps, {}> {
    private getStyles(): IReactRadiumFreeStyles {
        const styleParams = this.props.styleParams;
        return {
            fieldOuter: {
                position: 'relative',
                textAlign: 'left'
            },
            label: {
                display: 'block',
                fontSize: '14px',
                marginTop: 0,
                marginBottom: 6,
                color: Color(styleParams.neutralColor)
                    .darken(0.6)
                    .hexString()
            },
            input: {
                width: '100%',
                lineHeight: '32px',
                fontSize: '16px',
                height: 32,
                border: '1px solid ' + styleParams.neutralColor,
                padding: '0px 2px',
                borderRadius: '3px',
                ':focus': {
                    outline: 'none'
                }
            },
            validationError: {
                display: 'block',
                color: styleParams.baseAccentColor,
                minHeight: 20,
                lineHeight: '20px',
                fontSize: '12px'
            }
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    prepareInputProps(props: IFormComponentProps) {
        const { id, onChange, onBlur, onFocus } = props;
        return {
            id,
            onBlur,
            onFocus,
            onChange: evt => {
                onChange(evt.target.value);
            }
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        const styles = this.getStyles();
        const label =
            this.props.label ||
            this.i18n(
                'js.auth.pages.login.fields.' + this.props.formProps.id.toLowerCase() + '.label'
            );
        return (
            <div key="login-input-output" style={styles.fieldOuter}>
                <label style={styles.label} htmlFor={this.props.formProps.id}>
                    {label}
                </label>
                <input
                    style={styles.input}
                    disabled={this.props.disabled}
                    id={this.props.formProps.id}
                    type={this.props.type ? this.props.type : 'text'}
                    {...this.prepareInputProps(this.props.formProps)}
                />
                <div key="error" style={styles.validationError}>
                    {this.props.formProps.validationErrorMessage}
                </div>
            </div>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default LoginInput;
